module.exports = __webpack_public_path__ + "images/emoji/sos.da1c126f1ba81c513f76.png";